<template>
  <div class="event">
    <div class="map">
      <iframe
        :src="location.map"
        width="100%"
        height="150"
        frameborder="0"
        style="border: 0"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
      ></iframe>
    </div>
    <div class="event-body text-left">
      <h3>{{ title }}</h3>
      <ul class="list-unstyled">
        <li>
          <i class="material-icons">event</i>
          <span>{{ $moment(start).format("dddd, DD MMMM YYYY") }}</span>
        </li>
        <li>
          <i class="material-icons">schedule</i>
          <span>{{ $moment(start).format("HH:mm") }} - {{ end }} WITA</span>
        </li>
        <li>
          <i class="material-icons">place</i>
          <span>{{ location.address }}</span>
        </li>
      </ul>

      <a :href="location.direction" class="d-flex align-items-center justify-content-center text-uppercase py-2 btn btn-primary">
        <i class="material-icons mr-2">follow_the_signs</i>
        Tunjukan Arah
      </a>
    </div>
  </div>
</template>

<script>
import AGWMap from "@/components/Maps";

export default {
  components: {
    AGWMap,
  },
  props: {
    location: Object,
    title: String,
    start: String,
    end: String,
  }
};
</script>

<style scoped lang="scss">
.event {
  box-shadow: 0 3px 15px rgba(0, 0, 0, .15);
  background: #ffffff;
  margin-bottom: 2rem;
  border-radius: 8px;
  overflow: hidden;

  .btn {
    letter-spacing: 3px;
  }
}

.event-body {
  padding: 1rem;

  h3 {
    font-size: 1.25rem;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 2px;
  }

  ul {
    margin-top: 1rem;

    li {
      display: flex;
      // align-items: center;
      margin-bottom: .75rem;
      font-size: 0.9rem;

      i {
        margin-right: .5rem;
      color: #444;
      }
    }
  }
}
</style>
